import VideoRoomSettings from './VideoRoomSettings'

export default VideoRoomSettings
